module.exports = __webpack_public_path__ + "media/images/official/voice_noriko-83f976a15173ad8288944959ad4f92dd.png";